import { render, staticRenderFns } from "./kft.vue?vue&type=template&id=b620e00a&scoped=true"
import script from "./kft.vue?vue&type=script&lang=js"
export * from "./kft.vue?vue&type=script&lang=js"
import style0 from "./kft.vue?vue&type=style&index=0&id=b620e00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b620e00a",
  null
  
)

export default component.exports